import React from 'react'
import AsyncCreatableSelect from 'react-select/async-creatable'

export default props => (
  <AsyncCreatableSelect
    placeholder="Selecionar"
    {...props}
  />
)
